(() => {
  if (window.__cmAcademiaReady) return;
  window.__cmAcademiaReady = true;

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const courseHandles = [
    '/products/curso-profesional-de-mecanica-y-mantenimiento-de-maquinas-de-coser-domesticas',
    '/products/curso-mantenimiento-reparacion-maquinas-industriales',
    '/products/academia-cosemania'
  ];
  let runQueued = false;
  let cartGuardLastRun = 0;
  let resizeTimer;

  function cleanPath() {
    return location.pathname.replace(/\/$/, '');
  }

  function isAcademiaLanding() {
    const path = cleanPath();
    return path === '/pages/cosemania-formacion' || path === '/pages/academia-cosemania';
  }

  function isCourseApp() {
    return location.pathname.includes('/apps/my/courses');
  }

  function isAcademiaProduct() {
    return courseHandles.some((handle) => location.pathname.includes(handle));
  }

  function isProduct() {
    return location.pathname.includes('/products/');
  }

  function isCartSurface() {
    return location.pathname.replace(/\/$/, '') === '/cart' || !!$('cart-drawer.active,cart-drawer.animate.active,cart-drawer[open],#CartDrawer.active,.cart-drawer.active');
  }

  function isAcademiaSurface() {
    return isAcademiaLanding() || isCourseApp() || isAcademiaProduct();
  }

  function track(eventName, detail = {}) {
    const payload = { event: eventName, area: 'academia_cosemania', path: location.pathname, ...detail };
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (error) {}
    try {
      if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish(eventName, payload);
    } catch (error) {}
    try {
      if (typeof window.fbq === 'function') window.fbq('trackCustom', eventName, payload);
    } catch (error) {}
  }

  function markSurface() {
    document.documentElement.dataset.cmAcademiaReady = 'true';
    document.documentElement.classList.toggle('cm-academia-surface', isAcademiaSurface());
    document.documentElement.classList.toggle('cm-course-app', isCourseApp());
    document.documentElement.classList.toggle('cm-academia-landing', isAcademiaLanding());
    document.documentElement.classList.toggle('cm-product-surface', isProduct());
  }

  function guardAnnouncementSlider() {
    if (!isAcademiaSurface() || !window.customElements || window.__cmAcademiaSliderGuard) return;
    window.__cmAcademiaSliderGuard = true;
    customElements.whenDefined('slideshow-component').then(() => {
      const component = customElements.get('slideshow-component');
      const proto = component?.prototype;
      if (!proto || typeof proto.applyAnimationToAnnouncementBar !== 'function' || proto.__cmAcademiaGuarded) return;
      const original = proto.applyAnimationToAnnouncementBar;
      proto.applyAnimationToAnnouncementBar = function guardedApplyAnimationToAnnouncementBar(...args) {
        try {
          return original.apply(this, args);
        } catch (error) {
          if (isAcademiaSurface() && /classList/i.test(String(error?.message || error))) return undefined;
          throw error;
        }
      };
      proto.__cmAcademiaGuarded = true;
    }).catch(() => {});
  }

  function swapAcademiaLogo() {
    if (!isAcademiaSurface() || window.__cmAcademiaLogoApplied) return;
    const template = $('[data-cm-academia-logo]');
    const image = template?.content?.querySelector('img') || $('.cm-academia__brand-mark img,.cm-course-product__brand-mark img');
    const target = $('header .header__heading-link,.header__heading-link,header a[href="/"]');
    if (!image || !target) return;
    const cloned = image.cloneNode(true);
    cloned.classList.add('cm-academia-header-logo__image');
    target.innerHTML = '';
    target.appendChild(cloned);
    target.classList.add('cm-academia-header-logo');
    target.setAttribute('aria-label', image.alt || 'Cosemania Formacion');
    window.__cmAcademiaLogoApplied = true;
  }

  function hideShadow(element) {
    if (!element.shadowRoot) return;
    let style = element.shadowRoot.getElementById('cm-academia-shadow-suppress');
    if (!style) {
      style = document.createElement('style');
      style.id = 'cm-academia-shadow-suppress';
      element.shadowRoot.appendChild(style);
    }
    style.textContent = '#app-embed,.appEmbed,[data-testid="app-router"],[data-testid="form-teaser"],.activator-nudge,button.activator{display:none!important;visibility:hidden!important;pointer-events:none!important;opacity:0!important;transform:scale(0)!important}';
  }

  function clearSuppressed() {
    $$('[data-cm-academia-suppressed="true"]').forEach((element) => {
      element.removeAttribute('data-cm-academia-suppressed');
      element.removeAttribute('aria-hidden');
    });
    $$('shopify-forms-embed,shopify-chat').forEach((element) => {
      const style = element.shadowRoot?.getElementById('cm-academia-shadow-suppress');
      if (style) style.remove();
    });
  }

  function suppressAcademiaObstacles() {
    if (!isAcademiaSurface()) {
      clearSuppressed();
      return;
    }

    [
      'shopify-chat',
      'shopify-forms-embed',
      '#ShopifyChat',
      '#shopify-chat',
      '[id*="shopify-chat" i]',
      '[id*="ShopifyChat" i]',
      '#app-embed-container-260559',
      '[id^="app-embed-container"]',
      '#PBarNextFrameWrapper',
      '[id^="PBar"]',
      '[id*="PBar"]',
      'body > .gta-widget.gta-bar',
      'body > [class*="gta-bar" i]',
      'body > [class*="GSC-BAR" i]',
      '[class*="pbar" i]',
      '[class*="privy" i]',
      '[class*="klaviyo-form" i]',
      '.announcement-bar',
      '.announcement-bar-section',
      '.utility-bar',
      '.cosemania-free-shipping-bar',
      '.cosemania-cart-shipping-indicator',
      '.cm-shipping-line',
      '.cm-cart-shipping',
      '.cm-cart-paybar',
      '.cm-product-shipping-note',
      '.cx-mobile-bar'
    ].forEach((selector) => {
      $$(selector).forEach((element) => {
        if (element.closest('.cm-academia-topbar,.shopify-pc__banner,.shopify-pc__prefs')) return;
        element.dataset.cmAcademiaSuppressed = 'true';
        element.setAttribute('aria-hidden', 'true');
        hideShadow(element);
      });
    });
  }

  function cleanProductRecommenders() {
    if (!isProduct()) return;
    [
      '.cx-helper--product',
      '.cx-bundle',
      '.cx-mobile-bar',
      '[data-cx-product-helper]',
      '[data-cx-bundle]',
      '[id*="essential_upsell" i]',
      '[class*="essential-upsell" i]'
    ].forEach((selector) => $$(selector).forEach((element) => element.remove()));
  }

  function blockAcademiaPurchase() {
    if (!isAcademiaProduct()) return;
    const waitlistUrl = '/pages/cosemania-formacion#cm-academia-form';
    $$('product-form,form[action*="/cart/add"],.shopify-payment-button').forEach((element) => {
      if (element.closest('.cm-course-product')) return;
      element.setAttribute('hidden', 'hidden');
      element.setAttribute('aria-hidden', 'true');
    });
    $$('form[action*="/cart/add"]').forEach((form) => {
      if (form.dataset.cmAcademiaPurchaseBlocked === 'true') return;
      form.dataset.cmAcademiaPurchaseBlocked = 'true';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        window.location.href = waitlistUrl;
      }, true);
    });
    $$('button[name="add"],form[action*="/cart/add"] button[type="submit"],.shopify-payment-button__button').forEach((button) => {
      if (button.closest('.cm-course-product')) return;
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    });
  }

  function showAcademiaCartNotice() {
    if ($('#cm-academia-cart-notice')) return;
    const notice = document.createElement('div');
    notice.id = 'cm-academia-cart-notice';
    notice.className = 'cm-academia-cart-notice';
    notice.innerHTML = '<strong>Curso en preparación.</strong><span>Lo hemos retirado del carrito para evitar un pago antes de tiempo. Puedes dejar tu interés en Cosemania Formación.</span><a href="/pages/cosemania-formacion#cm-academia-form">Reservar interés</a>';
    const target = $('main,#MainContent,.cart-drawer,#CartDrawer') || document.body;
    target.insertAdjacentElement(target === document.body ? 'afterbegin' : 'afterbegin', notice);
  }

  async function removeAcademiaCourseFromCart() {
    if (!isCartSurface() || window.__cmAcademiaCartGuardRunning) return;
    if (Date.now() - cartGuardLastRun < 1200) return;
    cartGuardLastRun = Date.now();
    window.__cmAcademiaCartGuardRunning = true;
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const items = Array.isArray(cart.items) ? cart.items : [];
      const courseItems = items.filter((item) => {
        const handle = `/products/${item.handle || item.product_handle || ''}`;
        return courseHandles.some((courseHandle) => courseHandle === handle);
      });
      if (!courseItems.length) return;

      await Promise.all(courseItems.map((item) => fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      }).catch(() => null)));

      const hasPhysicalItems = items.some((item) => !courseItems.includes(item));
      track('cm_academia_cart_purchase_blocked', { items: courseItems.length, has_physical_items: hasPhysicalItems });
      if (!hasPhysicalItems && location.pathname.replace(/\/$/, '') === '/cart') {
        window.location.href = '/pages/cosemania-formacion#cm-academia-form';
      } else {
        showAcademiaCartNotice();
      }
    } catch (error) {
      track('cm_academia_cart_guard_error');
    } finally {
      window.__cmAcademiaCartGuardRunning = false;
    }
  }

  function ensureTopbar() {
    const existing = $('#cm-academia-topbar');
    if (!isCourseApp()) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;

    const bar = document.createElement('nav');
    bar.id = 'cm-academia-topbar';
    bar.className = 'cm-academia-topbar';
    bar.setAttribute('aria-label', 'Navegacion de Academia Cosemania');
    bar.innerHTML = '<a class="cm-academia-topbar__brand" href="/pages/cosemania-formacion">Cosemania Formaci&oacute;n</a><div class="cm-academia-topbar__links"><a href="/pages/cosemania-formacion#cm-academia-form" data-cm-academia-track="topbar_waitlist">Lista de espera</a><a href="/pages/cosemania-formacion#temario" data-cm-academia-track="topbar_syllabus">Temario</a><a href="/pages/cosemania-formacion#cm-academia-form" data-cm-academia-track="topbar_help">Enviar duda</a></div>';

    const main = $('main,#MainContent');
    if (main) main.insertAdjacentElement('beforebegin', bar);
    else document.body.insertAdjacentElement('afterbegin', bar);
  }

  function enhanceCourseApp() {
    if (!isCourseApp() || $('#cm-course-app-intro')) return;
    const host = $('main,#MainContent,#apCB') || document.body;
    const intro = document.createElement('section');
    intro.id = 'cm-course-app-intro';
    intro.className = 'cm-course-app-intro';
    intro.innerHTML = '<p>Cosemania Formaci&oacute;n</p><h1>Zona de alumno</h1><span>Cuando el curso abra, aqu&iacute; tendr&aacute;s tus clases organizadas. Mientras lo preparamos, puedes volver a la p&aacute;gina de Formaci&oacute;n y dejarnos tu duda o tu caso.</span>';
    host.insertAdjacentElement(host === document.body ? 'afterbegin' : 'beforebegin', intro);
  }

  function bindAcademiaClicks() {
    $$('[data-cm-academia-track]').forEach((element) => {
      if (element.dataset.cmAcademiaTrackBound === 'true') return;
      element.dataset.cmAcademiaTrackBound = 'true';
      element.addEventListener('click', () => track('cm_academia_click', {
        action: element.dataset.cmAcademiaTrack,
        label: (element.textContent || '').trim().slice(0, 80)
      }));
    });
  }

  function bindLeadForm() {
    const form = $('#ContactAcademia');
    if (!form || form.dataset.cmAcademiaAjaxBound === 'true') return;
    form.dataset.cmAcademiaAjaxBound = 'true';

    const status = $('[data-cm-academia-form-status]', form);
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const formData = new FormData(form);
      const machine = formData.get('contact[Tipo de maquina]') || '';
      const goal = formData.get('contact[Objetivo]') || '';

      form.classList.add('is-sending');
      if (status) {
        status.hidden = false;
        status.classList.remove('cm-academia__form-status--error');
        status.textContent = 'Enviando solicitud...';
      }
      track('cm_academia_lead_submit_attempt', { machine, goal });

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error('Contact form failed');
        form.reset();
        if (status) status.textContent = 'Solicitud recibida. Te contactaremos desde Cosemania con los proximos pasos.';
        track('cm_academia_lead_submit_success', { machine, goal });
      } catch (error) {
        if (status) {
          status.classList.add('cm-academia__form-status--error');
          status.textContent = 'No hemos podido enviar la solicitud ahora. Revisa los campos o intentalo de nuevo en unos minutos.';
        }
        track('cm_academia_lead_submit_error', { machine, goal });
      } finally {
        form.classList.remove('is-sending');
      }
    });
  }

  function bindCourseAppEvents() {
    if (window.__cmCourseAppEventsBound) return;
    window.__cmCourseAppEventsBound = true;
    ['onCoursesRendered', 'onLessonRendered', 'onOpenLessonRendered', 'onQuizRendered', 'onCoursesQuizPassed'].forEach((eventName) => {
      const previous = window[eventName];
      window[eventName] = (...args) => {
        document.documentElement.dataset.cmCourseAppEvent = eventName;
        track('cm_course_app_event', { event_name: eventName });
        if (typeof previous === 'function') previous.apply(window, args);
        setTimeout(scheduleRun, 40);
      };
      window.addEventListener(eventName, () => {
        document.documentElement.dataset.cmCourseAppEvent = eventName;
        track('cm_course_app_event', { event_name: eventName });
        setTimeout(scheduleRun, 40);
      });
    });
  }

  function run() {
    const academiaSurface = isAcademiaSurface();
    const courseApp = isCourseApp();
    const productSurface = isProduct();
    const cartSurface = isCartSurface();

    markSurface();
    if (academiaSurface) {
      guardAnnouncementSlider();
      swapAcademiaLogo();
      suppressAcademiaObstacles();
      blockAcademiaPurchase();
      ensureTopbar();
      enhanceCourseApp();
      bindAcademiaClicks();
      bindLeadForm();
    } else {
      suppressAcademiaObstacles();
      ensureTopbar();
    }
    if (productSurface) cleanProductRecommenders();
    if (cartSurface) removeAcademiaCourseFromCart();
    if (courseApp) bindCourseAppEvents();
  }

  function scheduleRun() {
    if (runQueued) return;
    runQueued = true;
    requestAnimationFrame(() => {
      runQueued = false;
      run();
    });
  }

  function mutationNeedsRun(mutations) {
    if (isAcademiaSurface() || isProduct() || isCartSurface()) return true;
    return mutations.some((mutation) => {
      return [...mutation.addedNodes].some((node) => {
        if (node.nodeType !== 1) return false;
        const text = `${node.tagName || ''} ${node.id || ''} ${node.className || ''}`;
        return /cart|drawer|product-form|course|academia|shopify-chat|shopify-forms|PBar|privy|klaviyo|gta|gsc|cx-|cm-/i.test(text);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => {
    if (isAcademiaSurface()) track('cm_academia_view', { surface: 'academia' });
    scheduleRun();
  }, { once: true });
  else {
    if (isAcademiaSurface()) track('cm_academia_view', { surface: 'academia' });
    scheduleRun();
  }

  window.addEventListener('shopify:section:load', scheduleRun);
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach((eventName) => document.addEventListener(eventName, scheduleRun));
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(scheduleRun, 180);
  }, { passive: true });
  [450, 1400, 3200].forEach((delay) => setTimeout(scheduleRun, delay));
  new MutationObserver((mutations) => {
    if (mutationNeedsRun(mutations)) scheduleRun();
  }).observe(document.body, { childList: true, subtree: true });

  ['cart-drawer', '#CartDrawer', '.cart-drawer'].map((selector) => $(selector)).filter(Boolean).forEach((element) => {
    new MutationObserver(scheduleRun).observe(element, { attributes: true, attributeFilter: ['class', 'open'] });
  });
})();
